var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyAda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.80727 14.859C9.7582 15.7115 10.4145 16.4414 11.267 16.4904C11.2977 16.4904 11.3283 16.4904 11.359 16.4904C12.2177 16.4904 12.9107 15.7974 12.9046 14.9387C12.9046 14.08 12.2115 13.387 11.3529 13.3931C10.531 13.3931 9.8502 14.0371 9.80727 14.859Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.02798 14.4601C3.75198 14.4417 3.51278 14.6564 3.50051 14.9324C3.48825 15.2084 3.69678 15.4476 3.97278 15.4598C4.24878 15.4782 4.48185 15.2636 4.50025 14.9876C4.51865 14.7116 4.30398 14.4785 4.02798 14.4601Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70795 5.86771C9.95328 5.74504 10.0514 5.43838 9.92875 5.19304C9.80608 4.94771 9.49941 4.84958 9.25408 4.97224C9.00875 5.09491 8.91061 5.39544 9.03328 5.64078C9.15594 5.89224 9.45648 5.99651 9.70795 5.86771Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2783 8.60906C11.6586 8.41893 11.8119 7.9528 11.6218 7.57253C11.4316 7.19226 10.9655 7.03893 10.5852 7.22906C10.205 7.4192 10.0516 7.88533 10.2418 8.2656C10.4319 8.64586 10.898 8.7992 11.2783 8.60906Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99285 10.4925C6.28725 10.6826 6.67979 10.6029 6.87605 10.3085C7.06619 10.0141 6.98645 9.62155 6.69205 9.42529C6.39765 9.23515 6.00512 9.31489 5.80885 9.60929C5.61259 9.90369 5.69845 10.3024 5.99285 10.4925Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93032 14.1849C6.50098 14.1604 6.13912 14.4854 6.11458 14.9148C6.09005 15.3441 6.41512 15.706 6.84445 15.7305C7.27378 15.755 7.63565 15.43 7.66018 15.0006C7.68472 14.5774 7.35965 14.2094 6.93032 14.1849Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07334 19.3791C5.76054 19.5386 5.63174 19.9188 5.79121 20.2378C5.95068 20.5506 6.33094 20.6794 6.64988 20.5199C6.96268 20.3604 7.09148 19.9802 6.93201 19.6612C6.77254 19.3484 6.38614 19.2196 6.07334 19.3791Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07731 12.5837C9.50051 12.8597 10.0648 12.7431 10.3346 12.3199C10.6106 11.8967 10.4941 11.3325 10.0709 11.0626C9.64771 10.7866 9.08344 10.9031 8.81357 11.3263C8.53757 11.7434 8.65411 12.3077 9.07731 12.5837Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6249 8.5475C18.9807 8.78057 19.4652 8.68244 19.6983 8.3267C19.9313 7.97097 19.8332 7.48644 19.4775 7.25337C19.1217 7.0203 18.6372 7.11844 18.4041 7.47417C18.1649 7.83604 18.2631 8.31444 18.6249 8.5475Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2097 5.8189C20.4427 5.97223 20.7494 5.90476 20.9027 5.6717C21.0561 5.43863 20.9886 5.13196 20.7555 4.97863C20.5225 4.8253 20.2158 4.89276 20.0625 5.1197C19.9153 5.35276 19.9827 5.66556 20.2097 5.8189Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7434 13.381C17.8909 13.3319 17.1549 13.9882 17.112 14.8407C17.0629 15.6933 17.7192 16.4293 18.5717 16.4722C18.6024 16.4722 18.633 16.4722 18.6576 16.4722C19.5101 16.4722 20.2032 15.7791 20.2032 14.9205C20.2093 14.1047 19.5653 13.4239 18.7434 13.381Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7959 12.4735C12.0597 12.9949 12.5933 13.3261 13.1821 13.3261C14.0346 13.3261 14.7277 12.633 14.7277 11.7743C14.7277 11.5351 14.6725 11.2959 14.5621 11.0751C14.1757 10.3085 13.2434 10.0018 12.4829 10.3882C11.7162 10.7807 11.4095 11.713 11.7959 12.4735Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9228 10.4926C24.2356 10.3331 24.3583 9.94672 24.1988 9.63392C24.0394 9.32112 23.653 9.19845 23.3402 9.35792C23.0274 9.51739 22.9047 9.89765 23.058 10.2105C23.2236 10.5233 23.6039 10.6521 23.9228 10.4926Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9982 10.9833C19.5505 11.2103 19.3665 11.7561 19.5934 12.2039C19.8204 12.6516 20.3662 12.8356 20.814 12.6087C21.2617 12.3817 21.4457 11.8359 21.2188 11.3881C20.9918 10.9404 20.446 10.7625 19.9982 10.9833Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9301 5.58523C15.2797 5.60363 15.5802 5.33377 15.6047 4.98417C15.6293 4.63457 15.3533 4.33403 15.0037 4.3095C14.6541 4.2911 14.3535 4.55483 14.329 4.90443C14.3106 5.26017 14.5805 5.5607 14.9301 5.58523Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9262 9.59061C15.4291 9.62128 15.8585 9.23488 15.883 8.73194C15.9137 8.22901 15.5273 7.79968 15.0243 7.77514C14.5214 7.74448 14.0921 8.13088 14.0675 8.63381C14.043 9.13674 14.4233 9.56608 14.9262 9.59061Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99757 18.8887C10.4453 18.6618 10.6293 18.1159 10.4024 17.6682C10.1754 17.2204 9.62957 17.0364 9.18183 17.2634C8.7341 17.4903 8.5501 18.0362 8.77703 18.4839C9.00397 18.9316 9.54983 19.1156 9.99757 18.8887Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5221 10.9214C15.0559 11.639 15.2522 12.5958 15.9698 13.0619C16.6874 13.528 17.6442 13.3318 18.1103 12.6142C18.5765 11.8966 18.3802 10.9398 17.6626 10.4736C17.4111 10.308 17.1167 10.2222 16.8162 10.2222C16.2949 10.2222 15.8103 10.4859 15.5221 10.9214Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2183 17.3984C17.8319 16.6317 16.8996 16.325 16.1391 16.7114C15.3724 17.0978 15.0658 18.0301 15.4522 18.7906C15.8386 19.5573 16.7708 19.864 17.5314 19.4776C18.2919 19.0973 18.6047 18.1773 18.2244 17.4106C18.2244 17.4045 18.2244 17.4045 18.2183 17.3984Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9225 17.2882C20.4993 17.0122 19.935 17.1287 19.6651 17.5519C19.3891 17.9751 19.5057 18.5394 19.9289 18.8092C20.3521 19.0852 20.9163 18.9687 21.1862 18.5455C21.4622 18.1285 21.3457 17.5642 20.9225 17.2882Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8828 14.963C23.9074 14.5337 23.5823 14.1718 23.153 14.1473C22.7236 14.1228 22.3618 14.4478 22.3372 14.8772C22.3127 15.3065 22.6378 15.6684 23.0671 15.6929C23.4903 15.7174 23.8583 15.3862 23.8828 14.963Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0241 14.4117C25.7481 14.3933 25.5089 14.608 25.4966 14.884C25.4843 15.16 25.6929 15.3992 25.9689 15.4115C26.2449 15.4299 26.4779 15.2152 26.4963 14.9392C26.5086 14.6632 26.3001 14.4301 26.0241 14.4117Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0175 19.3794C23.7231 19.1893 23.3305 19.269 23.1343 19.5634C22.9441 19.8578 23.0239 20.2503 23.3183 20.4466C23.6127 20.6367 24.0052 20.557 24.2015 20.2626C24.3977 19.9682 24.3119 19.5695 24.0175 19.3794Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79914 24.0528C9.56607 23.8995 9.25941 23.967 9.10607 24.1939C8.95274 24.427 9.02021 24.7336 9.24714 24.887C9.48021 25.0403 9.78687 24.9729 9.94021 24.7459C10.0997 24.519 10.0322 24.2062 9.79914 24.0528Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2892 24.0036C20.0439 24.1263 19.9458 24.4329 20.0684 24.6783C20.1911 24.9236 20.4978 25.0217 20.7431 24.8991C20.9884 24.7764 21.0866 24.4759 20.9639 24.2305C20.8412 23.9791 20.5407 23.8748 20.2892 24.0036Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4825 18.95C14.9486 18.2324 14.7523 17.2756 14.0347 16.8033C13.3171 16.3372 12.3603 16.5334 11.8881 17.251C11.4158 17.9686 11.6182 18.9254 12.3358 19.3977C12.5873 19.5633 12.8817 19.6492 13.1822 19.6492C13.7097 19.6553 14.1942 19.3916 14.4825 18.95Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3873 21.3232C11.0315 21.0901 10.547 21.1883 10.3139 21.544C10.0809 21.8997 10.179 22.3843 10.5347 22.6173C10.8905 22.8504 11.375 22.7523 11.6081 22.3965C11.8473 22.0408 11.7491 21.5563 11.3873 21.3232Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0004 24.286C14.6508 24.2676 14.3503 24.5375 14.3257 24.8871C14.3012 25.2367 14.5772 25.5372 14.9268 25.5618C15.2764 25.5802 15.5769 25.3164 15.6015 24.9668C15.6199 24.6111 15.35 24.3106 15.0004 24.286Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0054 20.281C14.5024 20.2503 14.0731 20.6367 14.0486 21.1397C14.0179 21.6426 14.4043 22.0719 14.9072 22.0965C15.4102 22.121 15.8395 21.7407 15.864 21.2378C15.8947 20.741 15.5083 20.3055 15.0054 20.281Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7198 21.262C18.3395 21.4583 18.1862 21.9244 18.3824 22.3047C18.5787 22.685 19.0449 22.8383 19.4251 22.642C19.8054 22.4519 19.9587 21.9858 19.7686 21.6055C19.5723 21.2252 19.1062 21.0658 18.7198 21.262Z",
    fill: "#0033AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 21.252,
    fill: "white",
    transform: "translate(3.5 4.31006)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyAda);
export default __webpack_public_path__ + "static/media/Currency=ADA.a76e396c7d63ff4afe8d1f7b1eb50251.svg";
export { ForwardRef as ReactComponent };